import { RouterModule, Routes } from '@angular/router';

import { Component, OnInit, Input } from '@angular/core';
import { Timezone } from 'src/app/core/_helpers/timezones';
import { AuthenticationService } from 'src/app/core/authentication/Authentication.service';
import { User } from '../../../core/authentication/user';
// import { AngularFireStorage } from '@angular/fire/storage';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { Language } from 'src/app/core/_helpers/Language';
import * as firebase from 'firebase/app';
import { stringify } from '@angular/compiler/src/util';


@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss']
})
export class ProjectComponent implements OnInit {
  file: File;

  constructor(public auth: AuthenticationService,
    private _snackBar: MatSnackBar, private languaje: Language) { }

    @Input() public lenguaje: string;
    action: number = 1;

  ngOnInit() {
    this.lenguajeIni();
  }

  resultComp($event) {
    this.action = $event;
  }

  lenguajeIni() {
    this.languaje.IniLenguaje(this.lenguaje);
  }
  
  
}
